const Required = () => {
  return <span className="text-danger">*</span>;
};

export default Required;
